<!--
 태그형태의 멀티 셀렉트 박스
------------------------------------

-->
<template>
    <div :class="classObject" :style="[defaultCssVariables, cssVariables]">
        <multiselect
            :value="multiselectValue"
            @input="updateValue"
            tag-placeholder="Add this as new tag"
            :placeholder="placeholder"
            label="text"

            :options="options"

            track-by="val"
            :multiple="true"
            :taggable="true"
            @tag="addTag"


        >
            <template
                slot="singleLabel"
                slot-scope="{ option }">
                {{ option.text }}
            </template>

            <template slot="noResult">
                Not found element
            </template>

        </multiselect>

        <!-- 히든변수 -->
        <input
            v-for="(val, key) in value"
            :key="key"

            type="hidden"
            :name="name"
            :value="val"

            v-if="withHiddenInput"
        />

    </div>
</template>

<script>
    import InputBase from './base.vue';
    import Multiselect from 'vue-multiselect'

    export default {
        extends: InputBase,
        props: {

            /**
             * input 요소의 값
             *   선택된 값들의 순차배열
             *   [val, val, val...]
             */
            value: {
                type: Array,
                default: []
            },

            /**
             * 컴포넌트 내에 히든변수 작성
             */
            withHiddenInput: {
                type: Boolean,
                default: false,
            },


        },
        data: function () {
            let optionsCache = {};
            _.each(this.options, (opt) => {
                optionsCache[opt.val] = opt;
            });

            return {
                /**
                 * (object)
                 * multiselectValue 에서 val 값으로 빠르게 객체를 선택할 수 있도록 캐시처리
                 */
                optionsCache: optionsCache,
            };
        },
        components: {
            Multiselect
        },
        computed: {
            /**
             * 멀티셀렉트 컴포넌트에 전달할 value 배열
             *  - 현재 선택중인 object를 배열로 작성해서 반환한다
             * @return []
             */
            multiselectValue() {
                /**
                 * computed 계산될때, 익명함수 를 화살표함수로 쓰서 this.속성들을 바로사용하게되면,
                 * 해당 this.속성의 변경이 감지되지 않음.
                 * 속성의 변경이 감지될 수 있도록 화살표 함수 외부에서 명시적으로 this.속성을 사용함.
                 */
                let options = this.options;
                return _.map(this.value, (selected) => {
                    let opt = this.optionsCache[selected];

                    // 기존옵션에 없는데 새로 작성된경우 옵션객체를 생성해줌
                    if (! opt) {
                        opt = {
                            text: selected,
                            val: selected,
                        }
                    }
                    return opt;
                });
            },
        },
        methods: {
            /**
             * input 의 값이 변경되었음을 알리는 이벤트 발생
             *  - 리스너에 변경된 값을 인자로 전달
             * @param selected_array 선택된 항목들의 배열이 전달됨
             * */
            updateValue: function (selected_array) {
                // vue-multiselect 에서 이벤트가 발생한 경우에는 인자값으로 선택값이 바로 옴.
                let value = [];
                //console.log(selected_array);
                if (selected_array) {
                    value = _.map(selected_array, (item) => {
                  //      console.log(item);
                        return item.val;
                    });
                }
                //console.log(value);
                this.$emit('update:value', value);
            },

            /**
             * 새로운 태그작성에 대한 이벤트 리스너
             * @param newTag (string) 새로운 태그명
             */
            addTag: function (newTag) {
                const tag = {
                    text: newTag,
                    val: newTag,
                };

                // 옵션내역 추가
                this.options.push(tag);

                // 옵션 캐시 추가
                this.optionsCache[tag.val] = tag;

                // 상위 컴포넌트에 추가된 값을 추가해서 update 이벤트 발생
                let added = this.multiselectValue.concat([tag]);

                this.updateValue(added);
            },
        }
    }
</script>

